<template>
  <div>
    <Card title="Customer Lifetime Value">
      <template v-slot:body>
        <div>
          <div class="pb-6 flex justify-between items-start">
            <div class="flex items-center">
              <div class="mr-2">
                <date-range-picker
                  ref="picker"
                  :timePicker="false"
                  :showDropdowns="false"
                  :max-date="maxDate"
                  v-model="dateRange"
                  :opens="'right'"
                  @update="onChangeDate"
                  :auto-apply="true"
                >
                  <template v-slot:input="picker" >
                    From: {{ moment(picker.startDate) }} - To: {{ moment(picker.endDate) }}
                  </template>
                </date-range-picker>
              </div>
              <div class="">
                <download-excel
                  class="px-2 md:w-50"
                  :data="data"
                  :fields="excel_fields"
                  :meta="excel_meta"
                  worksheet="My Worksheet"
                  name="ltv.xls"
                >
                  <div v-bind:class="'bg-indigo-500 text-gray-100'" class="flex items-end p-4 bg-indigo-200 rounded-lg shadow-xs cursor-pointer hover:bg-indigo-500 hover:text-gray-100">
                    <p class="m-auto text-xs font-medium">
                      Download Excel
                    </p>
                  </div>
                </download-excel>
              </div>
            </div>
            <div class="pb-6 flex" style="gap: 16px;">
              <card-stats
                statSubtitle="Lifetime Avg In Days"
                :statTitle="lifetimeAvgInDays"
                stat-icon-name="fa fa-users"
              />
              <card-stats
                statSubtitle="Lifetime Revenue Avg"
                :statTitle="`$${lifetimeRevenueAvg}`"
              />
            </div>
          </div>
        </div>
        <data-tables-server ref="tableTransaction" :data="data" :total="total" :pagination-props="{ background: true,pageSizes: [displayingItem] }" @query-change="onChangeTable" >
          <el-table-column v-for="title in tableColumn" :prop="title.prop" :label="title.label" :key="title.prop" sortable="custom">
          </el-table-column>
        </data-tables-server>
      </template>
    </Card>
  </div>
</template>

<script>
import Vue from 'vue';
import DateRangePicker from 'vue2-daterange-picker';
import 'vue2-daterange-picker/dist/vue2-daterange-picker.css';
import { mapActions, mapGetters } from 'vuex';
import moment from 'moment';
import JsonExcel from 'vue-json-excel';
import { Button } from '@/components/Layout/Form';
import Card from '@/components/Layout/Card.vue';
import CardStats from '@/components/Layout/CardStats.vue';

Vue.component('downloadExcel', JsonExcel);
const displayingItems = 20;
export default {
  name: 'CLTVPage',
  data: () => ({
    data: [],
    total: 0,
    displayingItem: displayingItems,
    tableColumn: [
      {
        prop: 'name',
        label: 'Name',
      },
      {
        prop: 'email',
        label: 'Email',
      },
      {
        prop: 'days',
        label: 'Days',
      },
      {
        prop: 'months',
        label: 'Months',
      },
      {
        prop: 'years',
        label: 'Years',
      },
      {
        prop: 'frequency',
        label: 'Frequency',
      },
      {
        prop: 'lifetime_revenue',
        label: 'Lifetime Revenue',
      },
    ],
    filter: {
      page: 1,
      per_page: displayingItems,
      sortby: 'id',
      sortorder: 'desc',
      start_date: moment().subtract(1, 'month').format('YYYY-MM-DD'),
      end_date: moment().format('YYYY-MM-DD'),
    },
    dateRange: {
      startDate: moment().subtract(1, 'month').format('YYYY-MM-DD'),
      endDate: moment().format('YYYY-MM-DD'),
    },
    maxDate: moment().format('YYYY-MM-DD'),
    excel_fields: {
      Name: 'name',
      Email: 'email',
      Days: 'days',
      Months: 'months',
      Years: 'years',
      Frequency: 'frequency',
      'Lifetime Revenue': 'lifetime_revenue',
    },
    excel_meta: [
      [
        {
          key: 'charset',
          value: 'utf-8',
        },
      ],
    ],
  }),
  computed: {
    ...mapGetters('NotificationModule', ['getErrorCode', 'getMessage', 'getStatus']),
    ...mapGetters('CLTVModule', ['listUsers','lifetimeAvgInDays','lifetimeRevenueAvg','totalUsers']),
  },
  async mounted() {
    await this.requestListUsers(this.filter);
  },
  methods: {
    ...mapActions('CLTVModule', ['requestListUsers']),
    moment(date) {
      return moment(date).format('YYYY-MM-DD');
    },
    filterFormatUtc(params){
      const startUtc = moment(this.filter.start_date).utc().format('YYYY-MM-DD HH:mm:ss');
      const endUtc = moment(this.filter.end_date).utc().format('YYYY-MM-DD HH:mm:ss');
      return {
        ...this.filter,
        ...params,
        start_date: startUtc,
        end_date: endUtc,
      }
    },
    async onChangeDate(res) {
      this.filter = { ...this.filter,
        start_date: moment(res.startDate).format('YYYY-MM-DD'),
        end_date: moment(res.endDate).format('YYYY-MM-DD'),
        page: 1,
      };
      await this.requestListUsers(this.filterFormatUtc({
        page: 1,
      }));
    },
    async onChangeTable(queryInfo) {
      if (queryInfo.type === 'init') return;
      const pageSize = queryInfo.pageSize;
      this.displayingItem = pageSize;
      const page = queryInfo.page;
      let sortby = queryInfo.sort.prop;
      let sortorder = queryInfo.sort.order === 'descending' || typeof (queryInfo.sort.order) === 'undefined' ? 'asc' : 'desc';
      if (typeof (sortby) === 'undefined') {
        sortby = 'id';
      }
      sortorder = queryInfo.sort.order === 'descending' || typeof (queryInfo.sort.order) === 'undefined' ? 'asc' : 'desc';
      this.filter = Object.assign(this.filter, { per_page: this.displayingItem, sortorder, sortby, page });
      await this.requestListUsers(this.filterFormatUtc({}));
    },
  },
  watch: {
    listUsers: {
      immediate: true,
      async handler(val) {
        if (val) {
          this.data = [];
          this.listUsers.forEach((c)=>{
            this.data.push({
              name: c.name,
              email: c.email,
              days: c.days,
              months: c.months,
              years: c.years,
              frequency: c.frequency,
              lifetime_revenue: c.lifetime_revenue,
            });
          });
          this.total = this.totalUsers || 0;
        }
      },
    },
  },
  components: {
    DateRangePicker,
    Button,
    Card,
    CardStats
  },
};
</script>

<style>
.daterangepicker .calendars{
  display:flex !important;
}
</style>
<style scoped>
.z-1000{
  z-index: 1000;
}
.mx-400{
  max-height: 50%;
  height: 50vh;
}
</style>



// WEBPACK FOOTER //
// src/views/CLTV.vue